import { useState } from "react"
import SearchableDropdown from "../../../components/SearchableDropdown"
import { useSelector } from "react-redux"
import { selectCurrentRole } from "../../auth/authSlice"
import { PaperClipOutlined, CaretRightFilled, CaretLeftFilled } from "@ant-design/icons"

const CrmControls = ({ handleSelectedClientChange, clientOptions, selectedClient, setCreateClientAccountModalOpen, setClientDocumentModalOpen, handleCopyHouseHold, reportTemplates, handleGenerateReport, isCreateReportLoading }) => {

    const role = useSelector(selectCurrentRole)
    const [copyHouseHoldClient, setCopyHouseHoldClient] = useState(null)
    const [selectedReportTemplate, setSelectedReportTemplate] = useState(null)

    const onSelectedClientChange = (client) => {
        if(!client) {
            return
        }
        handleSelectedClientChange(client)
    }

    const getSelectedClientIndex = () => {
        if(!selectedClient || !clientOptions || clientOptions.length < 1) {
            return
        }

        let index
        clientOptions.forEach((client, idx) => {
            if(client.id.clientId === selectedClient.clientId) {
                index = idx
            }
        })

        return index
    }

    const selectPrevOrNextClient = (isPrev) => {
        let newSelectedClient = isPrev ? clientOptions[getSelectedClientIndex() - 1] : clientOptions[getSelectedClientIndex() + 1]
        if(newSelectedClient) {
            onSelectedClientChange(newSelectedClient.id)
        }
    }

    const getReportTemplateOptions = () => {
        return reportTemplates.map(template => ({id: template, name: template.templateName + " (" + template.templateType + ")"}))
    }

    return (
        <div className={`file-details-controls ${(role !== "ADVISOR" && role !== "SUPPORT_STAFF") || 'report'}`}>
            <div className="control">
                <h3 className="header">Client</h3>
                <div className="control-main">
                    <div className="client-dropdown-selector">
                        <button className="client-selector-prev" disabled={getSelectedClientIndex() === 0} onClick={() => selectPrevOrNextClient(true)}>
                            <CaretLeftFilled  />
                            <span class="tooltip">Previous client</span>
                        </button>
                        <div className="search-dropdown">
                            <SearchableDropdown
                                options={clientOptions}
                                label="name"
                                id="id"
                                selectedVal={selectedClient ? selectedClient.firstName + " " + selectedClient.lastName : null}
                                placeholderVal={"Select Client..."}
                                handleChange={(val, id) => onSelectedClientChange(id)}
                            />
                        </div>
                        <button className="client-selector-next" disabled={getSelectedClientIndex() + 1 >= clientOptions.length} onClick={() => selectPrevOrNextClient(false)}>
                            <CaretRightFilled  />
                            <span class="tooltip">Next client</span>
                        </button>
                    </div>
                    <div className="control-button">
                        <button onClick={() => setCreateClientAccountModalOpen(true)}>Create Account</button>
                    </div>
                    {
                        selectedClient && 
                        <div className="control-button">
                            <button onClick={() => setClientDocumentModalOpen(true)}>
                                <PaperClipOutlined  />
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div className="control">
                <h3 className="header">Copy Household</h3>
                <div className="control-main">
                    <div className="search-dropdown">
                        <SearchableDropdown
                            options={clientOptions}
                            label="name"
                            id="id"
                            selectedVal={copyHouseHoldClient ? copyHouseHoldClient.firstName + " " + copyHouseHoldClient.lastName : null}
                            placeholderVal={"Select Client..."}
                            handleChange={(val, id) => setCopyHouseHoldClient(id)}
                        />
                    </div>
                    <div className="control-button">
                        <button disabled={!(selectedClient && copyHouseHoldClient)} onClick={() => handleCopyHouseHold(copyHouseHoldClient)}>Copy</button>
                    </div>
                </div>
            </div>
            {(role === "ADVISOR" || role === "SUPPORT_STAFF") &&
                <div className="control">
                    <h3 className="header">Report</h3>
                    <div className="control-main">
                        <div className="search-dropdown">
                            <SearchableDropdown
                                options={getReportTemplateOptions()}
                                label="name"
                                id="id"
                                selectedVal={selectedReportTemplate ? selectedReportTemplate.templateName + " (" + selectedReportTemplate.templateType + ")" : null}
                                placeholderVal={"Select Report Template..."}
                                handleChange={(val, id) => setSelectedReportTemplate(id)}
                            />
                        </div>
                        <div className="control-button">
                            <button disabled={!selectedReportTemplate || isCreateReportLoading} onClick={() => handleGenerateReport(selectedReportTemplate)}>{isCreateReportLoading ? 'Generating Report...' : 'Generate'}</button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default CrmControls